import type { FaireProductEntity } from "../../entity_types/product";

export const p_6t62uyjw34: FaireProductEntity = {
  token: "p_6t62uyjw34",
  type: "product",
  name: "Bath Bombs with Squishy Friends Inside, PDQ Display",
  brandToken: "b_c0co3r5w",
  brandName: "Purposeful Bliss - Fizzy Magic",
  imageUrl:
    "https://cdn.faire.com/fastly/ff5937fe9d993e19a74890abf0b09ca8c224a2cb47b13a9b26fb1f1701217564.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3580d53c857244d448c2aaaee360ed80ec12a530a2eb611b349314da23f27f6c.jpeg",
    "https://cdn.faire.com/fastly/eadb6b99bd6a5350bb5d6ad8d8a6b9d7c68ef87c3d5adee11e0853697f093685.jpeg",
    "https://cdn.faire.com/fastly/d72a8086b5d158c3a55693b6adccdc1b89f8aed970d9a267d294fb348f8c7af2.jpeg",
    "https://cdn.faire.com/fastly/1825a5cea13cbfc77aeeb0ad13001493ec037dfa07500d0cec75817f7323fbe9.jpeg",
  ],
  priceDollars: 5,
  description:
    "Bath Bombs with Toys Inside, Squishy Surprises\nKid Favorites, Adults love them too\nFREE PDQ Display\n• 18 Blind Box - 7.5oz , 2 Color Fizzy Balls,  XL Softball Size Bath Bombs\n• 18 Different Squishy Surprises Inside (Random)\n• Pure & Safe Formula with Essential Oils\n• Color, Pink-Orange, Purple-Violet & Blue-Green, Blue/Pink, & Pink/Purple\nPerfect Christmas Stocking\n• Synthetic Free Scents: Pomegranate Blush, Blueberry Coconut & Cucumber Pear\nPerfect Gift, Bath Bombs for Birthday Gift\nValentine's Day or Easter Basket\n𝐎𝐮𝐫 𝐆𝐞𝐧𝐭𝐥𝐞 𝐅𝐨𝐫𝐦𝐮𝐥𝐚\nDesigned with bedtime in mind\n• Sodium Bicarbonate\n• (Baking Soda)\n• Food Grade Citric Acid\n• Epsom Salt\n• All Natural Fragrance Oil with Essential Oils\n• Safflower Oil\n• Avocado Oil\n• Ylang Ylang Essential Oil\n• Witch Hazel\n• EazyColours",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:03.334Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
